import { observer } from 'mobx-react-lite';
import { Button, Grid, Icon } from 'semantic-ui-react';
import { Image } from 'semantic-ui-react';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import { useStore } from '../../../app/stores/store';
import { PhotoType } from './CamModal';
import ImageTag from '../../../features/Profile/RenderImage';

interface Props {
  elem: any;
  onPhotoClick: (index: number) => void;
  index: number;
  isMandatory: boolean;
  errorMessage: string;
  disabled: any;
  RoleChecker: any;
}
function PhotoUpload({
  elem,
  onPhotoClick,
  index,
  isMandatory,
  errorMessage,
  disabled,
  RoleChecker,
}: Props) {
  const { commonStore } = useStore();
  const sampleImageArray = ['/assets/thumbnail.png', '/assets/thumbnail.png'];
  return (
    <>
      <Grid.Row style={{ marginBottom: '12px' }}>
        <Grid.Column>
          <label>
            {!!(disabled && RoleChecker) && (
              <Icon
                style={{
                  bottom: '-0.5px',
                  left: '1px',
                  position: 'relative',
                }}
                name="lock"
                color="grey"
              />
            )}
            <strong>{elem.elementName}</strong>
            {isMandatory ? <span style={{ color: '#9f3a38' }}>*</span> : null}
          </label>
        </Grid.Column>
      </Grid.Row>
      {elem?.photos?.length === 0 ? (
        isMandatory && errorMessage ? (
          sampleImageArray.map((e, i) => {
            return (
              <Image
                size="small"
                src={e}
                key={i}
                alt="/assets/documents.jpg"
                style={{
                  display: 'inline-block',
                  marginRight: '20px',
                  marginBottom: '20px',
                  borderRadius: '10px',
                  border: '1px solid #9f3a38',
                }}
              />
            );
          })
        ) : (
          sampleImageArray.map((e, i) => {
            return (
              <Image
                size="small"
                src={e}
                key={i}
                alt="/assets/documents.jpg"
                style={{
                  display: 'inline-block',
                  marginRight: '20px',
                  marginBottom: '20px',
                  borderRadius: '10px',
                }}
              />
            );
          })
        )
      ) : (
        <Grid.Row>
          {elem?.photos?.map((ph: PhotoType) => {
            return (
              <ImageTag
                key={ph.url}
                imageUrl={ph.url}
                defaultUrl="/assets/documents.jpg"
                style={{
                  display: 'inline-block',
                  marginRight: '20px',
                  marginBottom: '20px',
                  borderRadius: '10px',
                  height: '100px',
                }}
              />
            );
          })}
        </Grid.Row>
      )}
      {errorMessage && (
        <Grid.Row>
          <Grid.Column>
            <span className="errorStyles">{errorMessage}</span>
          </Grid.Column>
        </Grid.Row>
      )}
      <Grid.Row style={{ marginTop: '12px' }}>
        <Grid.Column width={16} style={{ display: 'flex', alignItems: 'end' }}>
          <Button primary onClick={() => onPhotoClick(index)} size="medium">
            <Icon
              name="camera retro"
              size="large"
              //Add Photographs
            />
            {
              (userLanguage[0].Level3InventoryRecievingVerify?.IRVB01 as any)?.[
                `${commonStore.language.key}`
              ]
            }
          </Button>
        </Grid.Column>
      </Grid.Row>
      {/* {addPhotos.map((url: PhotoType) => {
        return (
          <Segment>
            <Grid>
              <Grid.Column textAlign={"center"} key={url.url} width={2}>
                <Image src={url.url} alt="/assets/documents.jpg" />
              </Grid.Column>
            </Grid>
          </Segment>
        );
      })} */}
    </>
  );
}

export default observer(PhotoUpload);
